module.exports = __webpack_public_path__ + "img/users-icon.ffa2be9a.svg";